import { Injectable } from '@angular/core';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';
import { Observable } from 'rxjs';
import { CenterDepartment } from 'src/app/shared/models/center-department';
import { HttpResponse } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class CenterDepartmentService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllCenterDepartmentsForUserCenter(): Observable<CenterDepartment[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.centerDepartmentUrl}s`,
			'getAllCenterDepartmentsForUserCenter'
		);
	}

	getCenterDepartmentById(
		centerDepartmentId: number
	): Observable<CenterDepartment> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.centerDepartmentUrl}/${centerDepartmentId}`,
			`getCenterDepartmentById(${centerDepartmentId})`
		);
	}

	postCenterDepartment(
		centerDepartment: CenterDepartment
	): Observable<CenterDepartment> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.centerDepartmentUrl}`,
			`postCenterDepartment`,
			centerDepartment
		);
	}

	updateCenterDepartment(
		centerDepartment: CenterDepartment
	): Observable<CenterDepartment> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.centerDepartmentUrl}/${centerDepartment.id}`,
			`updateCenterDepartment`,
			centerDepartment
		);
	}

	deleteCenterDepartment(
		centerDepartmentId: number
	): Observable<HttpResponse<void>> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.centerDepartmentUrl}/${centerDepartmentId}`,
			`deleteCenterDepartment`
		);
	}
}
